import React from "react";
import PropTypes from "prop-types";
import { NavLink, Redirect } from "react-router-dom";

const Recipe = ({ recipe, viewingUser, userSlug, signedIn, favorites }) => {
  const stepStyle = {
    margin: "0.75em 0",
    borderBottom: "1px dotted",
    paddingBottom: "1.25em",
  };
  return (
    <div className="recipePage results">
      <div className="p-2 recipeCard">
        <p className="formTitle">{recipe.title}</p>
        <div className="recipePageTitle zigzag" />
        <div className="recipeDetails">
          {recipe.category && recipe.category.length && (
            <>
              <h5>Tags:</h5>
              <div className="tags">
                {recipe.category.map((category) => {
                  return <span key={category}>{category}</span>;
                })}
              </div>
            </>
          )}
          {recipe.difficulty && <p>Difficulty: {recipe.difficulty}</p>}
          {recipe.prepTime && <p>Prep time: {recipe.prepTime}</p>}
          {recipe.cookTime && <p>Cook time: {recipe.cookTime}</p>}
          {recipe.notes && <p>Notes: {recipe.notes}</p>}
          {recipe.ingredientList && (
            <>
              <p>Ingredients:</p>
              <ol>
                {recipe.ingredientList.map(([ingredient, measurement = ""]) => {
                  if (!measurement.length) {
                    return <li key={ingredient}>{ingredient}</li>;
                  }
                  return (
                    <li key={ingredient}>
                      {ingredient} - <i>{measurement}</i>
                    </li>
                  );
                })}
              </ol>
            </>
          )}
          {recipe.steps && (
            <>
              <p>Steps: </p>
              <ol>
                {recipe.steps.map((step) => {
                  return (
                    <li key={step} style={stepStyle}>
                      {step}
                    </li>
                  );
                })}
              </ol>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

Recipe.propTypes = {
  recipe: PropTypes.object.isRequired,
  viewingUser: PropTypes.object,
  signedIn: PropTypes.bool,
  userSlug: PropTypes.string,
  favorites: PropTypes.array,
};

export default Recipe;
